export const INITIALIZE_VEHICLES = 'initialize-vehicles';

const initializeVehicles = () => (
  { type: INITIALIZE_VEHICLES }
);

export default initializeVehicles;
